import _ from 'lodash';
import React, { useState, useMemo } from 'react';
import {
  Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import { PropTypes, NavLink, Icon } from '~/utils';
import { useConfig, useGlobalContext } from '~/context';

function useMenus() {
  const config = useConfig();
  const { member } = useGlobalContext();
  return useMemo( () => {
    const context = {
      member,
      config  : config.data,
      station : config.get( 'station' ),
    };
    return _.filter( config.get( 'menus' ), menu => {
      if ( ! menu.when ) return true;
      return Boolean( _.get( context, menu.when, false ) );
    } );
  }, [ member, config ] );
}

function Menu( { label, icon, items, to } ) {
  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret>
        <Icon icon={icon} label={label} />
      </DropdownToggle>
      <DropdownMenu right>
        {_.map( items, item => <MenuItem key={item.label} {...item} /> )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
Menu.propTypes = {
  label   : PropTypes.string.isRequired,
  items   : PropTypes.arrayOf( PropTypes.shape( MenuItem.propTypes ) ),
  icon    : PropTypes.string,
  to      : PropTypes.string,
};

function MenuItem( { divider, ...props } ) {
  if ( divider ) return <DropdownItem divider />;
  const navprops = _.pick( props, _.keys( NavLink.propTypes ) );
  return <DropdownItem><NavLink {...navprops} /></DropdownItem>;
}
MenuItem.propTypes = {
  divider   : PropTypes.bool,
  ...NavLink.propTypes,
};

function MenuButton( { label, icon, to } ) {
  return (
    <NavItem>
      <NavLink to={to}><Icon icon={icon} label={label} /></NavLink>
    </NavItem>
  );
}
MenuButton.propTypes = {
  label   : PropTypes.string.isRequired,
  icon    : PropTypes.string,
  to      : PropTypes.string,
};

export default function MenuBar( props ) {
  const menus = useMenus();
  const [ isOpen, setIsOpen ] = useState( true );
  const toggle = () => setIsOpen( prev => !prev );

  return (
    <Navbar color="light" light expand="md">
      <NavbarBrand href="/">Swiper</NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar>
          {_.map( menus, menu => {
            if ( menu.items ) {
              return <Menu key={menu.label} {...menu} />;
            } else if ( menu.to ) {
              return <MenuButton key={menu.label} {...menu} />;
            } else {
              throw new Error( `Invalid menu: ${menu}` );
            }
          } )}
        </Nav>
      </Collapse>
    </Navbar>
  );
}
